import { appendComponent } from '@/lego/utils/render/component';
import WeCallYouDialog from '@/lego/partials/home/WeCallYouDialog.vue';

export function createDialog(props = {}) {
  const okCallbacks = [];
  const cancelCallbacks = [];
  const dismissCallbacks = [];

  const onOk = cb => okCallbacks.push(cb);
  const onCancel = cb => cancelCallbacks.push(cb);
  const onDismiss = cb => dismissCallbacks.push(cb);

  const ok = evt => okCallbacks.forEach(cb => cb(evt));
  const cancel = evt => cancelCallbacks.forEach(cb => cb(evt));
  const dismiss = () => dismissCallbacks.forEach(cb => cb());

  const show = () => {
    appendComponent(WeCallYouDialog, document.querySelector('#app'), {
      props,
      on: { ok, cancel, dismiss },
    });
  };

  return {
    onOk,
    onCancel,
    onDismiss,
    show,
  };
}
